import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ConfirmDialogB, { ConfirmDefault } from "../components/ConfirmDialogB";
import { DefaultEditorValue } from "../technician/AdminMonthlyWork";
import { BuildsColumnsWithEdit } from "../../core/TableHelper";
import { DFRatioObj, DFRatioService } from "../../model/backoffice/df-ratio";
import {
  ConfirmsDeleteAction,
  GetCreateTable,
  GetListForm,
  ShowsEditor,
} from "../../core/Helper2";
import { IsCanDelete } from "../../core/Helper3";
import { TopToolBar } from "../../core/TopToolbar";
import DFRatioEditor from "./c0004-df-ratio-editor";

export default function DFRatioList(props) {
  const userInfo = useSelector((state) => state.user);
  const [table, setTable] = useState();
  const [confirm, setConfirm] = useState(ConfirmDefault);
  const [editor, setEditor] = useState(DefaultEditorValue);
  const [list, setList] = props.list;
  const [patientList, setPatientList] = useState(DefaultEditorValue);
  const [data, setData] = useState([]);
  const _idFiledsName = "DfRatioId";
  const dispatch = useDispatch();

  useEffect(() => {
    if (list?.show) {
      getData();
      return () => {
        console.log("DFRaeioList closed");
        setData([]);
        setTable(null);
      };
    }
  }, [list?.show]);

  useEffect(() => {
    if (data) {
      /**COLUMN */
      let columns = BuildsColumnsWithEdit(
        DFRatioObj({}),
        actionEdit,
        actionDelete
      );

      setTable(
        GetCreateTable({
          idFieldName: _idFiledsName,
          columns: columns,
          data: data,
        })
      );
    }
  }, [data]);

  const actionAddNew = () =>
    ShowsEditor(setEditor, _idFiledsName, 0, () => getData());
  const actionEdit = (x, row) =>
    ShowsEditor(setEditor, _idFiledsName, row[_idFiledsName], () => getData());

  const actionDelete = (x, row) => {
    if (!IsCanDelete(userInfo.userRule, dispatch)) return;
    ConfirmsDeleteAction(setConfirm, async () => {
      let res = await DFRatioService.DeleteItem(
        { [_idFiledsName]: row[_idFiledsName] },
        userInfo.detail
      );
      if (res) {
        getData();
      }
    });
  };

  const getData = async (text) => {
    let ret = await DFRatioService.GetList({ text: text }, userInfo.detail);
    if (ret) {
      setData(ret);
    }
    setEditor(DefaultEditorValue);
  };

  return (
    <>
      <GetListForm {...{ list: [list, setList], title: "ตั้งอัตราค่าตอบแทน" }}>
        <TopToolBar
          onAddNew={actionAddNew}
          searchHandler={(text) => getData(text)}
        ></TopToolBar>
        {table}
      </GetListForm>

      <DFRatioEditor {...{ editor: [editor, setEditor] }} />
      <ConfirmDialogB {...{ winState: [confirm, setConfirm] }} />
    </>
  );
}
